<template>
  <div class="consult-bottom"
       :class="{extend:showExtend,patReplyRemainNumber:setHeighterBottom}">
    <template v-if="isCancel">
      <div class="finish" v-if="isRenewal||isPersonal">
        <!--去掉按钮后，放置一个占位符-->
        <div class="bg"></div>
        <!--<v-common-btn @click="()=>$refs.kefu.show()">联系客服</v-common-btn>-->
      </div>
      <div v-else class="wait center flex" @click="handler(status)">
        咨询已取消<br />如有退款将在7~10个工作日返回您的支付账户
      </div>
    </template>

    <template v-else-if="isNopayCancel">
      <div class="finish" v-if="isPersonal">
        <!--去掉按钮后，放置一个占位符-->
        <div class="bg"></div>
        <!--<v-common-btn @click="()=>$refs.kefu.show()">联系客服</v-common-btn>-->
      </div>
      <div v-else class="wait center flex" @click="handler(status)">{{ consult.consultStatusDescription }}</div>
    </template>


    <div class="wait center flex" @click="handler(status)"
         v-else-if="isGoing && !consult.replyCount">
      {{ isPersonal ? "请等待医生回复，24小时后未回复自动退款" : consult.consultStatusDescription }}
    </div>


    <template v-else-if="isNeedPay">
      <!--<div class="rate" v-if="isRenewal">
              <ul class="flex">
                <li class="flex0 center" @click="handler('cancel')">取消申请</li>
                <li class="flex0 center" @click="handler(status)">
                  支付{{consult.consultFee}}元
                </li>
              </ul>
            </div>-->
      <div class="finish" v-if="isRenewal">
        <div class="flex0 center bg_main color_fff" @click="handler(status)">在线缴费</div>
      </div>
      <div class="rate" v-else>
        <ul class="flex">
          <li class="flex0 center" @click="handler('cancel')">取消申请</li>
          <li class="flex0 center" @click="handler(status)">
            支付{{ consult.consultFee }}元
          </li>
        </ul>
      </div>
    </template>

    <div class="rate" v-else-if="status=='NEEDCOMMENT'&&consult.patReplyRemainNumber<=0">
      <ul class="flex">
        <li @click="repeat" class="flex0 center">再次咨询</li>
        <router-link tag="li" :to="{path:'/comment',query:{consultId:consult.consultId}}" class="flex0 center">
          评价
        </router-link>
      </ul>
    </div>

    <div class="finish" v-else-if="status=='FINSH'&&consult.patReplyRemainNumber<=0">
      <div @click="repeat" class="flex0 center">再次咨询</div>
    </div>

    <div ref="replay" class="replay" v-else>
      <div class="num center fs13" v-if="consult.patReplyRemainNumber>0">
        您还能回复<span>{{ consult.patReplyRemainNumber }}</span>条
      </div>
      <div v-if="consult.patReplyRemainNumber==0" class="flex flex-center flex-center-2 color_999">
        {{ canReplyText }}
      </div>
      <div v-else class="flex">
        <div class="input flex1">
          <input ref="replayInput" @focus="handler('focus')" @blur="handler('blur')" type="text"
                 v-model="replyContent" />
        </div>
        <div class="btn flex0">
          <a v-if="!replyContent" @click="handler('plus')" class="upload center"><font
            class="iconfont">&#xe610;</font></a><!--@click="$refs.uploader.click()"-->
          <!--@click="showExtend=!showExtend"-->
          <a @click="send" class="sendmsg" v-else>发送</a>
        </div>
      </div>
      <div v-if="showExtend" class="extend-btns">
        <ul class="flex exts fwwrap">
          <li class="flex0 flex column flex-center-2 flex-center" v-for="(ext ,i) in exts" :key="i"
              @click="handlerExt(ext)">
            <div class="iconfont fs30 color_777" v-html="ext.icon"></div>
            <div class="text">{{ ext.label }}</div>
          </li>
        </ul>
      </div>
    </div>
    <uploader ref="uploader" @uploaded="uploaded" :accept="accept"></uploader>
    <consult-uploader ref="consultUploader" :multiple="true" :accept="accept" @pics="uploadAndReply"></consult-uploader>
    <consult-pdf-uploader ref="consultPdfUploader" @pdfs="uploadAndReplyPdfs"></consult-pdf-uploader>
    <user-kefu ref="kefu"></user-kefu>
  </div>
</template>
<script>
import { handlerHTML, sleep } from "../../lib/util";
import http from "../../lib/api";
import weuijs from "weui.js";
import Uploader from "../../plugins/upload";
import VCommonBtn from "../v-common-btn";
import UserKefu from "../user/kefu";
import { ACCEPT_TYPE, CANCEL, CONSULT_TYPE_MAP, GOING, NOPAY_CANCEL } from "@/lib/config";
import { consultMixin } from "@/lib/mixins/consult";
import ConsultUploader from "@/plugins/consult/consult-uploader";
import { VERSION5_3_0 } from "@/lib/version";
import uploadApi from "@/lib/uploadApi";
import { consultService } from "@/services/consult";
import ConsultPdfUploader from "@/plugins/consult/consult-pdf-uploader";
import { Notify } from "vant";

const EXTS = [
  { label: "图片", icon: "&#xe638;", id: "pic" },
  { label: "视频", icon: "&#xe651;", id: "video" },
  { label: "PDF附件", icon: "&#xe61b;", id: "pdf" },
  { label: "VIP宣教", icon: "&#xec6f;", id: "tumour", path: "/tumour/news" }
];
export default {
  mixins: [consultMixin],
  props: ["status", "message", "consult", "server"],
  data() {
    return {
      accept: "",
      showExtend: false,
      replyContent: "",
      exts: VERSION5_3_0 ? EXTS.slice(0, 3) : EXTS.slice(0, 2)
    };
  },
  computed: {
    canReplyText() {
      if (this.consultType === CONSULT_TYPE_MAP.PERSONAL_TIME_PIC)
        return "您今天的回复条数已用完，请明天再来";
      return "您的回复条数已用完，暂无法回复";
    },
    // 设置较高的底部
    setHeighterBottom() {
      const patReplyRemainNumber = this.consult.patReplyRemainNumber;
      return (patReplyRemainNumber > 0 && this.isGoing) || (patReplyRemainNumber > 0 && this.isFinish);
    }
  },
  components: { ConsultPdfUploader, ConsultUploader, UserKefu, VCommonBtn, Uploader },
  created() {
    this.timer = null;
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    reset() {
      this.replyContent = "";
      this.showExtend = false;
    },

    async uploadAndReplyPdfs(pdfs) {
      Notify({
        type: "primary",
        message: "上传中...",
        duration: 0
      });
      for (let i = 0; i < pdfs.length; i++) {
        const pdf = pdfs[i];
        if (!pdf) continue;
        this.reset();
        const { code: uploadErrorCode, obj: uploadResult } = await uploadApi(pdf, () => {
        });
        if (uploadErrorCode === "0") {
          const replyErrorCode = await consultService.replyDocument(this.consult.consultId, uploadResult.attaId);
          if (replyErrorCode === "0") {
            this.$emit("sendok", 1);
            await sleep(200);
          } else {
            bus.$emit("msg", `${pdf.name}发送失败`);
          }
        } else {
          bus.$emit("msg", `${pdf.name}上传失败`);
        }
      }
      Notify.clear();
    },


    async uploadAndReply(pics) {
      Log("uploadResult-pics", pics);
      if (pics.length > 9) return bus.$emit("msg", "最多选择9张");
      for (let i = 0; i < pics.length; i++) {
        const pic = pics[i];
        const file = pic.file;
        if (!file) continue;
        this.reset();
        const { code: uploadErrorCode, obj: uploadResult } = await uploadApi(file, () => {
        });
        if (uploadErrorCode === "0") {
          Log("uploadResult", uploadResult);
          const replyErrorCode = await consultService.replyPic(this.consult.consultId, uploadResult.attaId);
          if (replyErrorCode === "0") {
            this.$emit("sendok", 1);
            await sleep(200);
          } else {
            bus.$emit("msg", `${file.name}发送失败`);
          }
        } else {
          bus.$emit("msg", `${file.name}上传失败`);
        }
      }
    },


    handlerHTML,
    repeat() {
      if (this.consult.consultType == "TEAMPIC") {
        this.$router.push({ path: "/team/" + this.consult.teamId + "/detail" });
      } else {
        this.$router.push({ path: "/onlineDoctorCard", query: { docId: this.consult.docId } });
      }
    },
    handlerExt(data) {
      switch (data.id) {
        case "pic":
          this.accept = ACCEPT_TYPE.image;
          this.$nextTick(() => {
            if (VERSION5_3_0) {
              this.$refs.consultUploader.start();
            } else
              this.$refs.uploader.click();
          });
          break;
        case "pdf":
          this.$refs.consultPdfUploader.start();
          break;
        case "video":
          this.accept = ACCEPT_TYPE.video;
          this.$refs.uploader.click("CONSULT_MESSAGE");
          break;
        case "tumour":
          this.$router.push({
            path: data.path,
            query: {
              healthInfomationServeId: this.server && this.server.id
            }
          });
          break;
      }
    },
    handler(type) {
      let { server, status, consult } = this;
      switch (type) {
        case "focus":
        case "blur":
          this.intoView(type);
          break;
        case "NEEDPAY":
          this.$router.push({
            path: "/videoPay", query: {
              consultId: this.consult.consultId,
              back: "list"
            }
          });
          break;
        case "cancel":
          weuijs.confirm("是否确认取消申请？", () => {
            this.cancel();
          });
          break;
        case "plus":
          this.showExtend = !this.showExtend;
          if (server && server.id) {// 团队服务包
            this.exts = EXTS;
            if (!VERSION5_3_0) {
              this.exts.splice(2, 1);
            }
            //this.showExtend = !this.showExtend;
          } //else this.$refs.uploader.click();
          break;
      }
    },
    intoView(type) {
      let replyEl = this.$refs.replayInput;
      switch (type) {
        case "focus":
          this.showExtend = false;
          replyEl && replyEl.scrollIntoViewIfNeeded();
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.timer = setTimeout((res) => {
            this.intoView(type);
          }, 300);
          break;
        case "blur":
          clearTimeout(this.timer);
          this.timer = null;
          break;
      }
    },
    uploaded(res) {
      if (res.code == 0) {
        this.send(res.obj);
      }
      //this.send(res);
    },
    async send(data) {
      let loading = weuijs.loading("加载中...");

      let params = {
        consultId: this.consult.consultId
      };

      if (this.replyContent) {
        params.replyContent = this.replyContent;
      } else {
        if (data.type) {
          params.replyContent = data.url;
          params.msgType = data.type;
        } else
          params.attaIdList = [data.attaId];
      }


      let ret = await http("nethos.consult.info.reply", params);
      if (ret.code == 0) {
        this.replyContent = "";
        this.showExtend = false;
        this.$emit("sendok", ret);
      } else {

      }
      loading.hide();
    },
    async cancel() {
      let loading = weuijs.loading("加载中...");
      let service = "nethos.consult.info.cancel";
      if (this.isPersonal) service = "nethos.consult.info.personal.cancel";
      let ret = await http(service, {
        consultId: this.consult.consultId
      });
      if (ret.code == 0) {
        weuijs.toast("取消成功", {
          callback: () => {
            this.$emit("cancel");
          }
        });
      }
      loading.hide();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/public";

$h: 50px;
$extend: 100px;
$tip: 25px;

.notice {
  left: 0;
  bottom: $h;
  z-index: 2001;
}

.extend-btns {
  height: $extend;

  ul {
    height: $extend;
  }
}

.consult-bottom.extend {
  height: $h+$extend;

  &.patReplyRemainNumber {
    height: $tip+$h+$extend;
  }
}

.consult-bottom {
  height: $h;

  &.patReplyRemainNumber {
    height: $tip+$h;
  }

  .wait {
    background-color: $bgColor;
    font-size: 13px;
    color: #333;
    height: $h;
    justify-content: center;
    align-items: center;
    line-height: 1.2;
  }

  .rate {
    li {
      @include h_lh($h);
      width: 50%;
      font-size: 16px;
    }

    li:nth-child(2) {
      color: white;
      background-color: $mainColor;
    }
  }

  .finish {
    div {
      @include h_lh($h);
      width: 100%;
      font-size: 16px;
    }
  }

  .replay {
    .num {
      line-height: $h / 2;
      height: $h / 2;
    }

    > .flex {
      height: $h;
      align-items: center;

      .btn {
        padding-right: 10px;

        .upload {
          font-size: 1.8em;
          display: block;

          font {
            color: #666666;
          }
        }

        .sendmsg {
          color: white;
          background-color: $mainColor;
          display: block;
          @include h_lh(30px);
          padding: 0 10px;
        }
      }

      .input {
        padding: 10px;

        input, textarea {
          width: 100%;
          font-size: 14px;
          height: 30px;
          background-color: $bgColor;
          border-radius: 5px;
        }
      }
    }
  }
}

.exts {
  li {
    width: 25%;
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/consult/bottom.vue